import { render, staticRenderFns } from "./DocumentStatut.vue?vue&type=template&id=4af6bdaa&scoped=true&"
import script from "./DocumentStatut.vue?vue&type=script&lang=js&"
export * from "./DocumentStatut.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStatut.vue?vue&type=style&index=0&id=4af6bdaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6bdaa",
  null
  
)

export default component.exports